import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSplitDetailGet } from '@/entities/splits/modules/api/splits';

export const useSplitDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiSplitDetailGet(id ?? ''),
    keywords: queryKeys.splits.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
